import clsx from 'clsx';

const Toggle = ({ checked, onChange }) => {
    return (
        <button
            type="button"
            onClick={onChange}
            className={clsx(
                "relative inline-flex h-8 w-20 items-center rounded-full transition-colors duration-200 focus:outline-none",
                {
                    'bg-[#2BCC71]': checked,
                    'bg-gray-400': !checked
                }
            )}
        >
            <span
                className={clsx(
                    "inline-block h-6 w-12 transform rounded-full bg-white transition-transform duration-200 shadow-sm",
                    {
                        'translate-x-7': checked,
                        'translate-x-1': !checked
                    }
                )}
            />
        </button>
    );
};

export default Toggle;
